import { pickT } from "@repo/shared";
import type { ProductCostsSource } from "@repo/shared/types";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { T } from "./product-costs-source-select.i18n";

type ProductCostsSourceSelectProps = {
  language: string;
  value: ProductCostsSource | undefined;
  onChange: (source: ProductCostsSource) => void;
  /** Explains where "existing" applies; each editor words it for its context. */
  hint: string;
};

/**
 * QL-417 — "New portfolio" / "Existing portfolio" for the product costs
 * component, shared by the flow component settings and the PDF template editor.
 */
export function ProductCostsSourceSelect({
  language,
  value,
  onChange,
  hint,
}: ProductCostsSourceSelectProps) {
  const t = pickT(T, language);

  return (
    <div className="space-y-2">
      <Label htmlFor="product-costs-source">{t.portfolioSource}</Label>
      <Select
        value={value === "existing" ? "existing" : "new"}
        onValueChange={(v) => onChange(v as ProductCostsSource)}
      >
        <SelectTrigger id="product-costs-source">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="new">{t.newPortfolio}</SelectItem>
          <SelectItem value="existing">{t.existingPortfolio}</SelectItem>
        </SelectContent>
      </Select>
      <p className="text-sm text-muted-foreground">{hint}</p>
    </div>
  );
}
